module.exports = __webpack_public_path__ + "img/dig02.99e74d21.png";